import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { regenerateInvoicePDF } from '../../services/pdfService'; // ✅ Correct

const InvoiceHistoryModal = ({ isOpen, closeModal, student, invoices }) => {
  if (!isOpen || !student) return null;

  return (
    <div className="payment-modal-overlay">
      <div className="payment-modal">
        <div className="payment-modal-header">
          <h2>Invoice History for {student.name}</h2>
          <button
            className="modal-close-btn"
            onClick={closeModal}
          >
            &times;
          </button>
        </div>

        <div className="payment-modal-content">
          {invoices.length === 0 ? (
            <p>No invoices found for this student.</p>
          ) : (
            <table className="invoice-table">
              <thead>
                <tr>
                  <th>Receipt No.</th>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Installment</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {invoices.map((invoice) => (
                  <tr key={invoice.id}>
                    <td>{invoice.receipt_no}</td>
                    <td>{invoice.paymentDate}</td>
                    <td>₹{parseFloat(invoice.paidAmount).toFixed(2)}</td>
                    <td>{invoice.paymentInstallment || 'N/A'}</td>
                    <td>
                      <button
                        className="download-invoice-btn"
                        onClick={() => regenerateInvoicePDF(invoice, student)}
                      >
                        <FontAwesomeIcon icon={faDownload} /> Download
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="payment-modal-actions">
          <button
            className="btn-cancel"
            onClick={closeModal}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvoiceHistoryModal;